import React from "react";
import {UninstallElement} from "../../../models/operations/UninstallElement";
import {ProcessStep} from "../../../models/ProcessStep";
import {EElementType} from "../../../models/utils/EElementType";
import ElementService from "../../ElementService";
import SelectElementTypeStep from "../../../components/steps/select/SelectElementTypeStep";
import {AElement} from "../../../models/elements/AElement";
import StepsAccordingToSpecificationsService from "../StepsAccordingToSpecificationsService";

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 18/05/2022
 * @last_update 18/05/2022
 **/
class ElementUninstallationSteps {

    public getElementUninstallationSteps(operation: UninstallElement, setOperation: (operation: UninstallElement) => void) : ProcessStep[] {
        let steps: ProcessStep[] = [];
        steps.push(this.getSelectElementTypeStep(operation, setOperation));
        steps = steps.concat(this.getElementIdentificationStep(operation, setOperation));
        return steps;
    }

    private getElementIdentificationStep(operation: UninstallElement, setOperation: (operation: UninstallElement) => void): ProcessStep[] {
        const steps: ProcessStep[] = [];
        const element = operation.oldElement;
        const setElement = (element: AElement) => {
            operation.oldElement = element;
            setOperation(operation);
        }
        if(element) {
            steps.push(StepsAccordingToSpecificationsService.getIdentificationStep(element.type, setElement, element));
        }
        return steps;
    }

     private getSelectElementTypeStep(operation: UninstallElement, setOperation: (operation: UninstallElement) => void) {
        const setElementType = (elementType: EElementType) => {
            if(operation.oldElement === undefined || operation.oldElement.type !== elementType) {
                operation.oldElement = ElementService.createsElementAccordingToType(elementType);
                setOperation(operation);
            }
        }
        return new ProcessStep("steps.titles.uninstall-element", this.getSelectElementTypeComponent(setElementType, operation.oldElement?.type));
     }

    private getSelectElementTypeComponent(setElementType: (elementType: EElementType) => void, elementType?: EElementType) {
        return <SelectElementTypeStep initialElementType={elementType} onValidate={setElementType}/>
    }

}

export default new ElementUninstallationSteps();
